import React from 'react'
import { useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Alert } from 'vnetwork-ui'
import TicketIcons from '@/icons/TicketIcons'
import TicketGroupType from '../../Forms/TicketGroupType'
import TicketType from '../../Forms/TicketType'
import SectionHeader from '../section-header'
import { CreateTicketSectionProps } from '../types'
import { TicketType as TicketTypeResponse } from '../../../types/response'

interface ClassificationSectionProps extends CreateTicketSectionProps {
    onChangeTicketTypeGroup: (value: string) => void
    onChangeTicketType: (
        ticketType: Partial<
            TicketTypeResponse & { value: number; label: string }
        >
    ) => void
    disabled?: boolean
}

const ClassificationSection: React.FC<ClassificationSectionProps> = ({
    control,
    watch,
    setValue,
    onChangeTicketTypeGroup,
    onChangeTicketType,
    disabled = false,
}) => {
    const { t } = useTranslation()
    const [searchParams] = useSearchParams()

    const isDisabled = disabled || !!searchParams.get('ticket_type')

    return (
        <div className="bg-white rounded-md p-4 border border-gray-100">
            <SectionHeader
                step={1}
                title={t('ticket-classification')}
                icon={<TicketIcons className="w-4 h-4" />}
            />
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div data-tour="ticket-type-group">
                    <TicketGroupType
                        control={control}
                        onChange={onChangeTicketTypeGroup}
                        disabled={isDisabled}
                    />
                </div>
                <div data-tour="ticket-type">
                    <TicketType
                        control={control}
                        handleChangeTicketType={onChangeTicketType}
                        defaultTicketType={
                            searchParams.get('ticket_type') || undefined
                        }
                        disabled={isDisabled}
                        ticketTypeGroup={watch('ticket_type_group')}
                        onTicketTypeGroupDetected={(group) => {
                            setValue('ticket_type_group', group)
                        }}
                        hasJourneyId={!!searchParams.get('customer_journey_id')}
                    />
                </div>
                {watch('ticket_type_group') === 'error_service' && (
                    <Alert variant="info" className="md:col-span-2 col-span-1">
                        {t('ticket-error-service-notice')}
                    </Alert>
                )}
            </div>
        </div>
    )
}

export default ClassificationSection
